import tokens from '@lansforsakringar/core-tokens'
import { css } from 'lit'

import { scoped, declare, vars } from '#utils/styles'

export const locals = scoped('spinner', [
	'color_primary',
	'color_secondary',
	'single_color',
	'size',
	'internal_size',
	'line_width',
	'outline_width',
	'background'
] as const)

export default css`
	:host {
		${declare(locals, {
			color_primary: tokens.color_border_brand_primary,
			color_secondary: tokens.color_border_brand_secondary,
			line_width: '3px', // TODO: Token is missing
			outline_width: tokens.border_width_emphasis,
			background: 'transparent'
		})};

		display: inline-block;
		vertical-align: middle;
	}

	.spinner {
		position: relative;
		display: block;
		background: ${vars(locals.background)};
		border: ${vars(locals.outline_width)} solid;
		border-color: ${vars(locals.color_primary)};
		border-radius: 50%;
		width: calc(${vars(locals.size, locals.internal_size)} / 16 * 1rem);
		height: calc(${vars(locals.size, locals.internal_size)} / 16 * 1rem);
		user-select: none;
		outline: ${vars(locals.outline_width)} solid;
		outline-color: ${vars(locals.background)};
		animation: rotation 1400ms linear infinite;

		&::after {
			content: '';
			box-sizing: border-box;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			width: calc(100% - ${vars(locals.outline_width)} * 2);
			height: calc(100% - ${vars(locals.outline_width)} * 2);
			border-radius: 50%;
			border: ${vars(locals.line_width)} solid transparent;
			border-bottom-color: ${vars(locals.color_secondary)};
		}

		&.monochrome {
			border-color: ${vars(locals.single_color)};

			&::after {
				border-bottom-color: ${vars(locals.single_color)};
			}
		}

		&.small {
			border-bottom-color: transparent;
		}

		&.small::after {
			display: none;
		}
	}

	@keyframes rotation {
		0% {
			transform: rotate(0);
		}
		100% {
			transform: rotate(1turn);
		}
	}
`
